import { RestService } from './rest-service';
import { environment } from '../../../environments/environment';

export abstract class InsightsRestService extends RestService {

  host = environment.SERVICE_HOST;
  rootPath = '/api/insights';

}
